import { FeatureConfig } from '@/models/featureConfig'
import { Config, FeatureConfigState } from '@/models/store'
import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore'
import { pick } from 'lodash-es'

import { transformValue } from './transformers'

const getConfigFromDocData = (data: FeatureConfig): Config => {
  const config = pick(data, [
    'active',
    'key',
    'namespace',
    'public',
    'type',
    'value'
  ])
  return {
    ...config,
    name: `${config.namespace}-${config.key}`.toLowerCase(),
    value: transformValue(config)
  }
}

const setFeatureConfigs = (
  state: FeatureConfigState,
  docs: QueryDocumentSnapshot<DocumentData>[]
) => {
  if (!docs) return
  const configs = docs.map((doc: DocumentData) =>
    getConfigFromDocData(doc.data())
  )
  state.configs = configs
}

export default {
  setFeatureConfigs
}
